

















import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { MessageInfo } from '../../core/components';
import { TrackingService } from '../../core/api';
import { UserService } from '../../core/api';
import {
    RootStoreHelper,
    AuthStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { clearLocalStorage } from '../../core/utils';

@Component({})
export default class NoCompaniesDialog extends Mixins(
    RootStoreHelper,
    AuthStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    showDialog: boolean = true;

    handleRefresh() {
        window.location.reload();
    }

    handleTour() {
        UserService.tourState(false)
            .then(() => {
                this.$_setTour(false);
                this.$_setMock(true);
                location.reload();
            })
            .catch(error => {
                if (error['message']) {
                    // this.$_errorToolbar(error['message']);
                } else {
                    this.$_errorToolbar('Error terminando el tour');
                }
            });
    }

    handleLogout() {
        clearLocalStorage();
        this.$_setSelectedVehicles([]);
        this.$_closeSession();
    }
}
